import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { adminApi } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = await adminApi.login(email, password);
      localStorage.setItem("cka_admin_token", data.access_token);
      localStorage.setItem("cka_admin_email", data.email);
      toast.success("Signed in");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-5">
      <form onSubmit={onSubmit} className="w-full max-w-md border border-white/10 bg-[#141414] p-10">
        <p className="overline mb-3">Studio</p>
        <h1 className="font-display text-4xl md:text-5xl mb-8">Admin Login</h1>
        <div className="mb-4">
          <label className="overline block mb-2">Email</label>
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="cka-input" />
        </div>
        <div className="mb-6">
          <label className="overline block mb-2">Password</label>
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="cka-input" />
        </div>
        <button data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Signing in..." : "Sign in"}</button>
        <p className="text-xs text-white/40 mt-6">Default credentials are set via .env. Change ADMIN_PASSWORD in production.</p>
      </form>
    </div>
  );
}
